import {
  BigInfoIcon,
  Card,
  Flex,
  Text,
  type BigInfoIconProps,
  type TextProps
} from "@theorgchartdev/storybook";
import { PropsWithChildren } from "react";

type UpgradeInfoCardProps = {} & BigInfoIconProps;

const UpgradeInfoCard = ({ children, ...props }: PropsWithChildren<UpgradeInfoCardProps>) => {
  return (
    <Card className="upgrade-card">
      <Flex direction={"column"} alignContent="center" justifyContent="center" alignItems="center">
        <BigInfoIcon color="brand" {...props}>
          {children}
        </BigInfoIcon>
      </Flex>
    </Card>
  );
};

const UpgradeInfoCardHeader = ({
  size = "large",
  modifier = "bold",
  style = { textAlign: "center" },
  children,
  ...rest
}: TextProps) => {
  return (
    <Text size={size} modifier={modifier} style={style} {...rest}>
      {children}
    </Text>
  );
};

const UpgradeInfoCardBody = ({
  size = "medium",
  style = { textAlign: "center" },
  children,
  ...rest
}: TextProps) => {
  return (
    <Text size={size} style={style} {...rest}>
      {children}
    </Text>
  );
};

UpgradeInfoCard.Header = UpgradeInfoCardHeader;
UpgradeInfoCard.Body = UpgradeInfoCardBody;

export { UpgradeInfoCard };
